export default {"src":"/_next/static/media/products-membership.866e7bb2.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};